<!----------------------------------------------------------Add/Edit New Project --------------------------------------------------------->

<!--Header-->
<div class="modal-header">
  <div class="modal-title">
    <h4>{{ modal_type }} {{ item.type }} Item</h4>
  </div>
  @if (missing_fields.length) {
    <div
      class="header-alert d-flex align-items-center"
      role="alert"
      >
      <i class="fa-solid fa-circle-exclamation me-2"></i>
      <span class="header-alert-prefix">Please fill in:</span>
      <div class="header-alert-chips">
        @for (field of missing_fields; track field) {
          <span class="header-alert-chip">{{ field }}</span>
        }
      </div>
      <button
        type="button"
        class="header-alert-close ms-2"
        aria-label="Dismiss"
        (click)="missing_fields = []"
        >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  }
  <button type="button" class="close-btn" (click)="cancelModalClick()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<!--body-->
<div class="modal-body-scroll">
  <form
    [formGroup]="product_service_form"
    (ngSubmit)="saveProductServiceClick()"
    >
    <!-- Type -->
    <div class="form-group d-flex align-items-center mb-3">
      <label for="type" class="form-label">Type:</label>
      <ng-select
        [items]="types"
        [multiple]="false"
        [closeOnSelect]="true"
        class="form-control flex-grow-1"
        formControlName="type"
        id="type"
      ></ng-select>
    </div>

    <!-- Name -->
    <div class="form-group d-flex align-items-center mb-3">
      <label for="name" class="form-label">
        <span class="text-danger me-1">*</span>Name:
      </label>
      <input
        type="text"
        id="name"
        class="form-control flex-grow-1"
        formControlName="name"
        placeholder="Enter name"
        />
      </div>

      <!-- UPC -->
      <div class="form-group d-flex align-items-center mb-3">
        <label for="upc" class="form-label">UPC:</label>
        <div class="d-flex flex-grow-1 gap-2">
          <input
            type="text"
            id="upc"
            class="form-control flex-grow-1"
            formControlName="upc"
            placeholder="Enter UPC"
            />
            <button
              class="btn modern-btn primary-btn"
              type="button"
              (click)="findItemByUpc()"
              >
              Search
            </button>
          </div>
        </div>

        <!-- Category -->
        @if (!isInventory) {
          <div class="form-group d-flex align-items-center mb-3">
            <label for="category" class="form-label">Category:</label>
            <ng-select
              [items]="accountingService.categories"
              [multiple]="false"
              [closeOnSelect]="true"
              class="form-control flex-grow-1"
              formControlName="category"
              id="category"
              placeholder="Select category"
            ></ng-select>
          </div>
        }

        <!-- Description -->
        <div class="form-group d-flex align-items-center mb-3">
          <label for="description" class="form-label">
            <span class="text-danger me-1">*</span>Description:
          </label>
          <input
            type="text"
            id="description"
            class="form-control flex-grow-1"
            formControlName="description"
            placeholder="Enter description"
            />
          </div>

          <!-- Reorder Point -->
          @if (isInventory) {
            <div class="form-group d-flex align-items-center mb-3">
              <label for="reorder_point" class="form-label">
                <span class="text-danger me-1">*</span>Reorder Point:
              </label>
              <input
                type="number"
                id="reorder_point"
                class="form-control flex-grow-1"
                formControlName="reorder_point"
                />
              </div>
            }

            <!-- Sale Price Rate -->
            <div class="form-group d-flex align-items-center mb-3">
              <label for="sale_price_rate" class="form-label">
                <span class="text-danger me-1">*</span>Sale Price Rate:
              </label>
              <input
                type="text"
                id="sale_price_rate"
                class="form-control flex-grow-1"
                formControlName="sale_price_rate"
                placeholder="0.00"
                (change)="checkForDecimal($event)"
                />
                <label for="margin_percentage" class="form-label ms-3 me-2 mb-0" style="width: auto;">
                  Margin %:
                </label>
                <input
                  type="number"
                  id="margin_percentage"
                  class="form-control"
                  formControlName="margin_percentage"
                  style="width: 100px;"
                  placeholder="10"
                  />
                </div>

                <!-- Cost -->
                @if (isInventory) {
                  <div class="form-group d-flex align-items-center mb-3">
                    <label for="cost" class="form-label">
                      <span class="text-danger me-1">*</span>Cost (Avg):
                    </label>
                    <input
                      type="text"
                      id="cost"
                      class="form-control flex-grow-1"
                      formControlName="cost"
                      placeholder="0.00"
                      (change)="checkForDecimal($event)"
                      />
                    </div>
                  }

                  <!-- Income Asset Account -->
                  <div class="form-group d-flex align-items-center mb-3">
                    <label for="income_asset_account" class="form-label">
                      @if (this.item.type === "Inventory") {
                        <span class="text-danger me-1">*</span>
                      }
                      Income Asset Account:
                    </label>
                    <ng-select
                      [items]="accountingService.inventory_asset_accounts"
                      [multiple]="false"
                      [closeOnSelect]="true"
                      class="form-control flex-grow-1"
                      formControlName="income_asset_account"
                      id="income_asset_account"
                    ></ng-select>
                  </div>

                  <!-- Income Account -->
                  <div class="form-group d-flex align-items-center mb-3">
                    <label for="income_account" class="form-label">
                      <span class="text-danger me-1">*</span>Income Account:
                    </label>
                    <ng-select
                      [items]="income_accounts"
                      bindLabel="name"
                      bindValue="name"
                      [multiple]="false"
                      [closeOnSelect]="true"
                      class="form-control flex-grow-1"
                      formControlName="income_account"
                      id="income_account"
                    ></ng-select>
                  </div>

                  <!-- Expense Account -->
                  <div class="form-group d-flex align-items-center mb-3">
                    <label for="expense_account" class="form-label">
                      <span class="text-danger me-1">*</span>Expense Account:
                    </label>
                    <ng-select
                      [items]="expense_accounts"
                      bindLabel="name"
                      bindValue="name"
                      [multiple]="false"
                      [closeOnSelect]="true"
                      class="form-control flex-grow-1"
                      formControlName="expense_account"
                      id="expense_account"
                    ></ng-select>
                  </div>

                  <!-- Inventory Asset Account -->
                  @if (isInventory) {
                    <div class="form-group d-flex align-items-center mb-3">
                      <label for="inventory_asset_account" class="form-label">
                        <span class="text-danger me-1">*</span>Inventory Asset Account:
                      </label>
                      <ng-select
                        [items]="accountingService.inventory_asset_accounts"
                        [multiple]="false"
                        [closeOnSelect]="true"
                        class="form-control flex-grow-1"
                        formControlName="inventory_asset_account"
                        id="inventory_asset_account"
                      ></ng-select>
                    </div>
                  }

                  <!-- Sales Tax -->
                  <div class="form-group d-flex align-items-center mb-3">
                    <label for="sales_tax" class="form-label">
                      <span class="text-danger me-1">*</span>Sales Tax:
                    </label>
                    <ng-select
                      [items]="[true, false]"
                      [multiple]="false"
                      [closeOnSelect]="true"
                      class="form-control flex-grow-1"
                      formControlName="sales_tax"
                      id="sales_tax"
                    ></ng-select>
                  </div>

                  <!-- Preferred Vendor -->
                  @if (isInventory) {
                    <div class="form-group d-flex align-items-center mb-3">
                      <label for="preferred_vendor" class="form-label"
                        >Preferred Vendor:</label
                        >
                        <ng-select
                          [items]="accountingService.vendor_list"
                          bindLabel="display_name"
                          bindValue="id"
                          [multiple]="false"
                          [closeOnSelect]="true"
                          class="form-control flex-grow-1"
                          formControlName="preferred_vendor"
                          id="preferred_vendor"
                          placeholder="Select vendor"
                        ></ng-select>
                      </div>
                    }

                    <!-- Serial Item -->
                    @if (isInventory) {
                      <div class="form-group d-flex align-items-center mb-3">
                        <label for="serial_item" class="form-label">Serial Item:</label>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="serial_item"
                            formControlName="serial_item"
                            />
                          </div>
                        </div>
                      }

                      <!-- Active -->
                      <div class="form-group d-flex align-items-center mb-3">
                        <label for="active" class="form-label">Active:</label>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="active"
                            formControlName="active"
                            />
                          </div>
                        </div>
                      </form>
                    </div>

                    <div class="modal-footer">
                      <div class="required-indicator me-auto">
                        <span class="text-danger">*</span>
                        <span style="margin-left: 5px">Denotes required fields</span>
                      </div>
                      <button
                        type="submit"
                        class="btn modern-btn primary-btn"
                        style="min-width: 180px"
                        [class.disabled]="product_service_form.invalid"
                        (click)="attemptSave()"
                        >
                        Save
                      </button>
                      <button
                        type="button"
                        class="btn modern-btn secondary-btn"
                        (click)="closeModalClick()"
                        >
                        Cancel
                      </button>
                    </div>

